module.exports = __webpack_public_path__ + "assets/img/logo.2ff558f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1